// ─────────────────────────────────────────────────────────────
// formatRelativeTime — shared helper.
// Returns a human-readable string like "just now", "5 min ago",
// "3h ago", "2 days ago", or a locale date string for older dates.
// Originally lived inside CommunityTab.tsx; extracted so the
// MaintenanceScreen + any other view can use it.
// ─────────────────────────────────────────────────────────────

export function formatRelativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return iso;
  const diffMs = Date.now() - then;
  const min = Math.floor(diffMs / 60_000);
  if (min < 1) return "just now";
  if (min < 60) return `${min} min ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const days = Math.floor(hr / 24);
  if (days < 7) return `${days} day${days === 1 ? "" : "s"} ago`;
  return new Date(iso).toLocaleDateString();
}
